var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed bottom-6 right-8 z-70 w-80 overflow-hidden"},[_c('transition-group',{attrs:{"tag":"ul","css":false},on:{"enter":_vm.messageEnter,"leave":_vm.messageLeave}},_vm._l((_vm.$feedback.messages),function(ref,index){
var id = ref.id;
var text = ref.text;
var status = ref.status;
var values = ref.values;
var lifetime = ref.lifetime;
return _c('feedback-message',{key:id,class:{ 'mt-px': index },attrs:{"id":id,"status":status,"text":text,"values":values,"lifetime":lifetime}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }